import React from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import {  FaGlobe, FaArrowRight,} from "react-icons/fa";
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaClock,
  FaPaperPlane,
  FaTruckMoving,
  FaTractor,
  FaHardHat,
} from "react-icons/fa";
import "./../App.css"
import { Link } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";

const ContactSection = () => {

const [name, setName] = React.useState("");
const [email, setEmail] = React.useState("");
const [description, setDescription] = React.useState("");
const [loading, setLoading] = React.useState(false);
const [error, setError] = React.useState("");
const [success, setSuccess] = React.useState("");

const handleSubmit = async (e) => {
  e.preventDefault();

  setError("");
  setSuccess("");

  if (!name || !email || !description) {
    setError("All fields are required");
    return;
  }

  try {
    setLoading(true);

    const res = await axios.post(
      "https://api.krimotion.in/add-web-query",
      {
        name,
        email,
       description
      }
    );

    setSuccess("Message sent successfully!");

    // clear form
    setName("");
    setEmail("");
    setDescription("");
    toast.success("Messgae send successfully!")

  } catch (err) {
    setError(err.response?.data?.message || "Something went wrong");
     toast.error("Failed to send message!")
  }

  setLoading(false);
};
  return (
    <>
   <section
  className="position-relative d-flex align-items-center justify-content-center text-center text-white"
  style={{
    backgroundImage:
      "linear-gradient(rgba(0,0,0,.65), rgba(0,0,0,.65)), url('https://images.unsplash.com/photo-1504307651254-35680f356dfd?q=80&w=1600&auto=format&fit=crop')",
    backgroundSize: "cover",
    backgroundPosition: "center",
    minHeight: "420px",
  }}
>
  <Container>

    <div className="d-flex justify-content-center gap-3 fs-2 mb-3">
      <FaTruckMoving />
      <FaTractor />
      <FaHardHat />
    </div>

    <div
      className="mx-auto mb-4"
      style={{
        width: "70px",
        height: "4px",
        background: "var(--primary-color)",
      }}
    ></div>

    <h1 className="display-3 fw-bold mb-3">
      Get In Touch
    </h1>

 <nav
  className="d-inline-flex align-items-center px-4 py-2"
  style={{ background: "var(--primary-color)" }}
>
  <Link
    to="/"
    className="text-white text-decoration-none fw-semibold"
  >
    Home
  </Link>

  <span className="mx-2 text-white">/</span>

  <span className="text-white">Contact Us</span>
</nav>

  </Container>
</section>
    <section className="py-5 bg-light">
      <Container>

        <Card className="border-0 shadow-lg overflow-hidden">
          <Row className="g-0">

            
            <Col
  lg={4}
  className="text-white p-5"
  style={{ background: "var(--primary-color)" }}
>

              <h3 className="fw-bold mb-5">
                Contact Details
              </h3>

              <div className="border-bottom pb-4 mb-4">
                <div className="d-flex">
                  <FaMapMarkerAlt className="fs-2 me-3 mt-1" />
                  <div>
                    <h6 className="fw-bold">Head Office Address</h6>
                    <p className="mb-0">
                      354 Oakridge Lane,
                      <br />
                      Camden, NJ 08102
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-bottom pb-4 mb-4">
                <div className="d-flex">
                  <FaPhoneAlt className="fs-2 me-3 mt-1" />
                  <div>
                    <h6 className="fw-bold"> Support</h6>
                    <p className="mb-0">
                      +91 98765 43210
                      <br />
                      +91 99887 66554
                    </p>
                  </div>
                </div>
              </div>

              <div className="border-bottom pb-4 mb-4">
                <div className="d-flex">
                  <FaGlobe className="fs-2 me-3 mt-1" />
                  <div>
                    <h6 className="fw-bold">Office Hours</h6>
                    <p className="mb-0">
                      Mon - Sat
                      <br />
                      9:00 AM - 6:00 PM
                    </p>
                  </div>
                </div>
              </div>

              <div className="d-flex">
                <FaEnvelope className="fs-2 me-3 mt-1" />
                <div>
                  <h6 className="fw-bold">Email</h6>
                  <p className="mb-0">
                  info@krimotion.in
                  </p>
                </div>
              </div>

            </Col>

          
            <Col lg={8} className="bg-white p-5">

              <h2 className="fw-bold">
                Send a Message
              </h2>

              <div
                className=" mb-4 "
                style={{ width: "70px", height: "4px",background:"var(--primary-color)" }}
              ></div>

              <p className="text-muted mb-4">
                Your email address will not be published. Required fields are marked *
              </p>

              <Form onSubmit={handleSubmit}>

                <Row>
                  <Col md={6} className="mb-3">
                    <Form.Control
                      className="rounded-0 py-3"
                      placeholder="Name *"
                        value={name}
                 onChange={(e) => setName(e.target.value)}
                    />
                  </Col>

                  <Col md={6} className="mb-3">
                    <Form.Control
                      className="rounded-0 py-3"
                      placeholder="Email *"
                        value={email}
  onChange={(e) => setEmail(e.target.value)}
                    />
                  </Col>
                </Row>

             

                <Form.Group className="mb-4">
                  <Form.Control
                    as="textarea"
                    rows={10}
                    className="rounded-0"
                    placeholder="Your Message"
                      value={description}
  onChange={(e) => setDescription(e.target.value)}
                  />
                </Form.Group>

      
       <Button
  type="submit"
  className="rounded-0 px-5 py-3 fw-bold text-white border-0"
  style={{
    backgroundColor: "var(--primary-color)",
  }}
>
  SEND MESSAGE
  <FaArrowRight className="ms-2" />
</Button>

              </Form>

            </Col>

          </Row>
        </Card>

      </Container>
    </section>
 
<section className="py-5 bg-light">
  <Container className="text-center mb-5">
    <span
      className="fw-semibold"
      style={{ color: "var(--primary-color)" }}
    >
      OUR LOCATION
    </span>

    <h2 className="display-5 fw-bold mt-2">
      Visit Our Office
    </h2>

    <p className="text-muted">
      We'd love to meet you. Visit our office or reach us through the
      details below.
    </p>
  </Container>


  <div className="container-fluid p-0">
    <iframe
      title="Google Map"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1801.3383407096655!2d81.86032443570524!3d25.44907070915729!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x398555df0e636aa3%3A0x85a9c468f03b08a2!2sDectwin%20services!5e0!3m2!1sen!2sin!4v1782466821834!5m2!1sen!2sin"
      width="100%"
      height="550"
      style={{
        border: 0,
        display: "block",
      }}
      allowFullScreen
      loading="lazy"
      referrerPolicy="strict-origin-when-cross-origin"
    />
  </div>
</section>

    
    </>
  );
};

export default ContactSection;